import {useRef, useState} from "react";
import "./about-us.scss";
import {AWS_S3_BUCKET} from "../../../global_vars";

function AboutUs() {

    const [state, setState] = useState("");

    const descriptionRef = useRef<HTMLDivElement>(null);
    const missionRef = useRef<HTMLDivElement>(null);
    const luxoraDubaiRef = useRef<HTMLDivElement>(null);
    const gatewayGrowthRef = useRef<HTMLDivElement>(null);


    const aboutUsHeaderImage = `${AWS_S3_BUCKET}/about_us_header.jpg`

    return (
        <div className="about-us">
            <div className="about-us-header">
                <img src={'Samples/about_us_header.jpg'} className={"about-us-header-image"}/>
                <h1 className={"about-us-title"}>ABOUT LUXORA DUBAI</h1>
            </div>
            <div className="about-us-body">
                <div className="about-us-description">
                    <div className="about-us-description-image">
                        <img src={'Samples/about_us_description.jpg'} className={"img-fluid"}/>
                    </div>
                    <div className="about-us-description-text">
                        <h1>MALIHA KHAN</h1>
                        <p>
                            Maliha Khan is a U.S. entrepreneur, real estate broker, and investment consultant based in
                            Dubai. As the CEO of Luxora Dubai, she has successfully guided high-net-worth individuals
                            (HNWIs) from around the world in securing high-yield, tax-free real estate investments in
                            Dubai’s thriving market.
                        </p>
                        <p>
                            With a proven track record of over AED 2 billion in real estate transactions, Maliha has
                            built a reputation for trust, transparency, and results. Her expertise bridges the gap
                            between U.S. investors and Dubai’s booming property sector, offering strategic insights that
                            help clients diversify their portfolios, maximize returns, and build long-term wealth.
                            Coming from a family with over a decade of experience in Dubai’s real estate sector, Maliha
                            has carried forward the legacy of success, leveraging her deep market knowledge and strong
                            relationships with top developers. Having lived in the U.S. for over a decade, where she ran
                            successful businesses, she understands the mindset of American investors and the challenges
                            they face when expanding globally.
                        </p>
                        <p>
                            Her mission is clear: to empower investors with the right knowledge, opportunities, and
                            expert guidance needed to make smart, secure, and highly profitable real estate investments
                            in Dubai. Maliha believes that strong family values translate into strong business values,
                            fostering a foundation of integrity, long-term success, and client satisfaction.
                        </p>
                    </div>

                </div>

                <div className="about-us-mission">
                    <div className="about-us-mission-image">
                        <img src={'Samples/about_us_mission.jpg'} className={"img-fluid"}/>
                    </div>
                    <div className="about-us-mission-text">
                        <h1>OUR MISSION</h1>

                        <blockquote>
                            <p>Empowering Global Investors with Lucrative Dubai Real Estate Opportunities</p>
                        </blockquote>

                        <p>
                            At Luxora Dubai, Our mission is to bridge the gap between international
                            investors, especially those in the U.S. and Dubai’s thriving real estate market. We aim
                            to provide unparalleled access, expert guidance, and high-yield opportunities in one of
                            the world’s fastest-growing and most investor-friendly real estate markets.
                        </p>
                        <p>
                            We believe that diversification is key to building long-term financial stability.
                            Relying
                            solely on U.S. real estate means tying your assets to one economy, which comes with
                            risks
                            such as market downturns, increasing tax burdens, and strict regulations. By investing
                            in Dubai, you’re expanding your portfolio globally, gaining exposure to a
                            booming, independent economy that offers high returns, financial
                            security, and long-term growth.
                        </p>
                    </div>
                </div>

                <div className="about-us-luxora-dubai">
                    <div className="about-us-luxora-dubai-overlay"></div>
                    <div className="about-us-luxora-dubai-image">
                        <img src={'Samples/about-us-luxora-dubai.jpg'} className={"img-fluid"}/>
                    </div>
                    <div className="about-us-luxora-dubai-text">
                        <h1>Why Choose Luxora Dubai?</h1>
                        <p>
                            At Luxora Dubai, we are not just brokers, We are your strategic investment partners. Our
                            team collaborates with all major developers in Dubai, ensuring our clients access exclusive
                            deals & Payment Plans, Priority project launches, and personalized investment strategies.
                        </p>
                        <p>
                            <span className="title">Award-Winning Broker Partnerships</span> {/*&ndash;*/} <br/> We have been recognized by Dubai’s top
                            developers, including <strong>Emaar, Damac, Dubai Properties, Sobha, Ellington and Danube</strong>,
                            for our outstanding performance.
                        </p>
                        <p>
                            <span className="title">Over AED 5 Billion in Sales</span> {/*&ndash;*/} <br/> Our track
                            record speaks for itself, having successfully
                            closed billions in real estate transactions, delivering exceptional results for
                            our investors.
                        </p>
                        <p>
                            <span className="title">U.S. to Dubai Investment Expertise</span> {/*&ndash;*/} <br/> We
                            specialize in helping American investors
                            understand and capitalize on Dubai’s market, ensuring seamless transactions, clear guidance,
                            and secure investments.
                        </p>
                        <p>
                            <span className="title">Tailored Investment Solutions</span> {/*&ndash;*/} <br/> Whether
                            you’re looking for short-term gains,
                            long-term appreciation, or passive rental income, we customize strategies based
                            on your financial goals.
                        </p>
                    </div>
                </div>

                <div className="about-us-gateway-growth">
                    <div className="about-us-gateway-growth-text">
                        <blockquote>
                            <h1>Your Gateway to International Wealth Growth</h1>
                        </blockquote>
                        <p>
                            Dubai isn’t just a city, it’s a global investment powerhouse. With zero property taxes, high
                            rental yields, and a booming economy, it offers an unmatched opportunity to grow
                            your wealth.
                            If you're looking to diversify your assets, maximize returns, and secure a foothold in
                            one of the world’s most dynamic markets, Luxora Dubai is here to guide you every
                            step of the way.
                        </p>
                        <p>
                            At Luxora, we assist our clients with business-related matters, particularly in
                            real estate and asset management. We're committed to ensuring the process is
                            smooth and financially rewarding.
                        </p>
                    </div>
                    <div className="about-us-gateway-growth-image">
                        <img src={'Samples/about-us-gateway-growth.jpg'} className={"img-fluid"}/>
                    </div>

                </div>

            </div>

        </div>
    );
}

export default AboutUs;